<template>
  <div class='opc-select-option__item'>
    <span>{{label}}</span>
    <template v-if="tooltipContent && tooltipContent.length">
      <zm-tooltip placement="top">
        <div slot="content" class="zm-select-dropdown__item__tooltips__content" v-html="tooltipContent"></div>
        <span aria-hidden class="zm-select-dropdown__item--tooltips zm-icon-help-outline"></span>
      </zm-tooltip>
    </template>
    <save-count
      v-if='isShowSaveCount'
      :annualPrice='annualPrice'
      :monthlyPrice='monthlyPrice'
    />
  </div>
</template>

<script>
import saveCount from '@/components/save-count.vue';
export default {
  name: 'opc-option-item',
  components: { saveCount },
  props: {
    label: String,
    disabled: {
      type: Boolean,
      default: false
    },
    tooltipContent: String,
    annualPrice: {
      type: Number,
      require: true
    },
    monthlyPrice: {
      type: Number,
      require: true,
    },
    isShowSaveCount: Boolean
  },
}
</script>

<style lang='scss' scoped>
.opc-select-option__item {
  display: flex;
  align-items: center;
  gap: 8px;

  ::v-deep .zm-select-dropdown__item--tooltips {
    margin-left: unset;
  }
}
</style>
